import { Fragment } from "react";

function PendingAccountStatusMessage() {
  return (
    <Fragment>
      <div>
        <h2>Thank You for Providing Your Information!</h2>
        <br />
        <p>
          Your account is currently <strong>pending verification</strong> with
          Stripe. This is a normal process to ensure all necessary details are
          correct and to comply with financial regulations.
        </p>
      </div>
    </Fragment>
  );
}

export default PendingAccountStatusMessage;
